// extracted by mini-css-extract-plugin
export default {"container":"yQAyAgmdDFOUFRuYyqbG","topText":"wFP3ar21KUJhaMHrTD0K"};